export default __webpack_public_path__ + "static/media/icon_smile.cc1e19be.svg";